import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import CollapsibleSection from './CollapsibleSection';
import IntervalTraining from './IntervalTraining';
import IntervalProduction from './IntervalProduction';
import ChordIdentification from './ChordIdentification';
import '../styles/ear-training.css';

const EarTraining = () => {
  const { t } = useLanguage();
  const [activeTab, setActiveTab] = useState('interval-training');

  const activities = [
    {
      id: 'interval-training',
      name: t('earTraining.activities.intervalTraining.name'),
      component: IntervalTraining,
      available: true
    },
    {
      id: 'interval-production',
      name: t('earTraining.activities.intervalProduction.name'),
      component: IntervalProduction,
      available: true
    },
    {
      id: 'chord-identification',
      name: t('earTraining.activities.chordIdentification.name'),
      component: ChordIdentification,
      available: true
    },
    {
      id: 'chord-recognition',
      name: t('earTraining.comingSoon.chordProgression'),
      component: null,
      available: false
    },
    {
      id: 'scale-recognition', 
      name: t('earTraining.comingSoon.scaleRecognition'),
      component: null,
      available: false
    },
    {
      id: 'rhythm-training',
      name: t('earTraining.comingSoon.rhythmTraining'),
      component: null,
      available: false
    }
  ];

  const renderTabs = () => (
    <div className="ear-training-tabs">
      {activities.map((activity) => (
        <button
          key={activity.id}
          className={`tab-button ${activeTab === activity.id ? 'active' : ''} ${!activity.available ? 'disabled' : ''}`}
          onClick={() => activity.available && setActiveTab(activity.id)}
          disabled={!activity.available}
        >
          {activity.name}
          {!activity.available && <span className="coming-soon-badge">Soon</span>}
        </button>
      ))}
    </div>
  );

  const renderTabContent = () => {
    const activity = activities.find(a => a.id === activeTab);
    
    if (!activity || !activity.available) {
      return (
        <div className="coming-soon-content">
          <div className="coming-soon-icon">⏳</div>
          <h3>{t('earTraining.comingSoon.title')}</h3>
          <p>This activity is coming soon! Stay tuned for updates.</p>
        </div>
      );
    }

    const ActivityComponent = activity.component;
    return <ActivityComponent />;
  };

  return (
    <CollapsibleSection
      title={t('earTraining.title')}
      icon="🎵"
      defaultExpanded={true}
      className="ear-training-section"
    >
      <div className="ear-training-container">
        <div className="ear-training-intro">
          <p className="ear-training-description">
            {t('earTraining.description')}
          </p>
        </div>
        
        {renderTabs()}
        
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default EarTraining;